module.exports = __webpack_public_path__ + "static/media/o0kta.ef72acad.jpg";